<template>
  <div>
    <Drawer title="编辑AgentApp" :visible="visible" :before-close="close">
      <template v-slot:default>
        <el-form ref="form" :model="form" label-width="120px" label-position="top" :rules="rules">
          <el-form-item label="id">
            <el-input disabled v-model="form.id"></el-input>
          </el-form-item>
          <el-form-item label="应用类型" prop="type">
            <el-radio-group disabled v-model="form.type">
              <el-radio label="chatflow"></el-radio>
              <el-radio label="workflow"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="应用名称" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="description">
            <el-input type="textarea" v-model="form.description"></el-input>
          </el-form-item>
          <!-- <el-form-item label="发布的流程配置">
            <div @click.stop="openJsonEdit('graph')">
              <div class="json-editor">
                {{ form.graph }}
              </div>
              <div class="tips">(点击进入编辑)</div>
            </div>
          </el-form-item>
          <el-form-item label="草稿流程配置">
            <div @click.stop="openJsonEdit('graph_draft')">
              <div class="json-editor">
                {{ form.graph_draft }}
              </div>
              <div class="tips">(点击进入编辑)</div>
            </div>
          </el-form-item> -->
          <!-- <el-form-item label="是否系统应用">
            <el-radio-group v-model="form.is_system">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
            </el-radio-group>
          </el-form-item> -->
          <el-form-item label="版本号">
            <el-input disabled v-model="form.version"></el-input>
          </el-form-item>
        </el-form>
      </template>
      <template v-slot:footer>
        <el-button class="drawer-footer-btn" type="primary" @click="updateAgentApp">保存</el-button>
        <el-button class="drawer-footer-btn" type="primary" @click="close">返回</el-button>
      </template>
    </Drawer>
    <json-edit
      v-if="showJson"
      type="edit"
      :show-json="showJson"
      :json="jsonData"
      title="发布的流程配置"
      @save="saveJson"
      @cancel="showJson = false"
    />
  </div>
</template>

<script>
import Drawer from '@/components/drawer';
import jsonEdit from '@/components/jsonEdit/index.vue';
export default {
  name: 'EditAgentAppDetail',
  components: { Drawer, jsonEdit },
  props: {
    row: { type: Object, default: () => {} },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showJson: false,
      currentJson: '',
      jsonData: '{}',
      form: {
        id: '',
        name: '',
        description: '',
        type: '',
        graph: '',
        graph_draft: '',
        is_system: false,
        version: '',
      },
      rules: {
        name: [{ required: true, message: '请输入应用名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择应用类型', trigger: 'blur' }],
        description: [{ required: true, message: '请填写描述', trigger: 'blur' }],
      },
    };
  },
  watch: {
    visible() {
      if (this.visible) {
        console.log(this.row.id);
        if (this.row.id) {
          this.$request({
            url: this.$api.getAgentAppById,
            data: {
              id: this.row.id,
            },
          }).then((res) => {
            this.form = res.agent_app;
          });
        }
      }
    },
  },
  mounted() {},
  methods: {
    close() {
      this.$emit('close');
    },
    onSubmit() {
      console.log('submit!');
    },
    openJsonEdit(key) {
      this.jsonData = this.form[key];
      this.currentJson = key;
      this.$nextTick(() => {
        this.showJson = true;
      });
    },
    saveJson(json) {
      this.form[this.currentJson] = JSON.stringify(JSON.parse(json));
      this.$nextTick(() => {
        this.showJson = false;
      });
    },
    updateAgentApp() {
      this.$refs.form.validate((valid) => {
        // valid
        console.log('%c Line:77 🥤 valid', 'color:#ffdd4d', valid);
        if (valid) {
          // updateAgentApp
          this.$request({
            url: this.$api.updateAgentApp,
            data: {
              id: this.row.id,
              agent_app: {
                ...this.form,
              },
            },
          }).then((res) => {
            console.log('%c Line:130 🍫 res', 'color:#33a5ff', res);
            this.$emit('refresh');
            this.close();
          });
        } else {
          this.$message.warning('请填写必填项');
        }
      });

      // console.log('%c Line:140 🌮 this.form', 'color:#fca650', this.form);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/button.scss';
@import '@/styles/element/form.scss';
@import '@/styles/element/radio.scss';
@import '@/styles/element/checkbox.scss';
@import '@/styles/element/input.scss';
@import '@/styles/element/select.scss';
.container {
  .row {
    margin-bottom: 8px;
    display: flex;
    .title {
      color: #98a2b2;
    }
    .text {
      flex: 1;
    }
  }
}
.drawer-footer-btn {
  margin-left: 8px;
}
.json-editor {
  background: #e5eaf2;
  height: 200px;
  overflow-x: scroll;
  overflow-y: scroll;
  cursor: pointer;
}
</style>
